/* ============================================================
   AI1 CART HEADER COUNT
   Adds a live total-quantity badge to the Prestige cart drawer
   header (#p-cd .p-ch-l h2 -> "Your Cart [N]").

   It does NOT touch the core cart logic. The Prestige controller
   (ai1-prestige.js) already keeps #cart-badge-count (the nav cart
   button badge) in sync with cart.item_count on initial load and
   after every add / quantity change / remove via ai1FetchCart().
   We simply MIRROR that authoritative value into a badge we inject
   into the drawer heading, using a MutationObserver so it stays in
   sync from one single source of truth. Always visible (shows 0).
   ============================================================ */
(function () {
  var GOLD = '#c8a96e';
  var NAVY = '#0e1c35';

  function injectStyleOnce() {
    if (document.getElementById('ai1-hdrcount-style')) return;
    var css =
      '#p-cd .p-ch-l h2 { display: inline-flex; align-items: center; gap: 10px; }' +
      '#p-cart-count {' +
      '  display: inline-flex; align-items: center; justify-content: center;' +
      '  min-width: 24px; height: 24px; padding: 0 8px; border-radius: 999px;' +
      '  background: ' + GOLD + '; color: ' + NAVY + ';' +
      "  font-family: 'Jost', sans-serif; font-size: 12px; font-weight: 600; line-height: 1;" +
      '}';
    var st = document.createElement('style');
    st.id = 'ai1-hdrcount-style';
    st.textContent = css;
    (document.body || document.head).appendChild(st);
  }

  function ensureBadge() {
    var h2 = document.querySelector('#p-cd .p-ch-l h2');
    if (!h2) return null;
    var span = document.getElementById('p-cart-count');
    if (!span) {
      injectStyleOnce();
      span = document.createElement('span');
      span.id = 'p-cart-count';
      span.setAttribute('aria-hidden', 'true');
      h2.appendChild(span);
    }
    return span;
  }

  function sync() {
    var nav = document.getElementById('cart-badge-count');
    var span = ensureBadge();
    if (!span) return;
    var val = nav ? (nav.textContent || '').trim() : '';
    span.textContent = val === '' ? '0' : val;
  }

  function init() {
    sync();
    var nav = document.getElementById('cart-badge-count');
    if (nav && 'MutationObserver' in window) {
      new MutationObserver(sync).observe(nav, {
        childList: true,
        characterData: true,
        subtree: true
      });
    }
    // Safety net: also resync shortly after load in case the nav badge
    // is populated by a late async cart fetch.
    setTimeout(sync, 600);
    setTimeout(sync, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ============================================================
   BEGIN AI1 PHASE 84.5 (DRAFT ONLY) - appended 2026-10-23.
   Rollback: delete from this comment through the END marker.

   D4  Header cart count (#cart-badge-count) went stale when an item was
       removed or a quantity changed on /cart, because only ai1FetchCart()
       (Prestige drawer) updated it while /cart uses Dawn's cart-items, which
       publishes PUB_SUB_EVENTS.cartUpdate. We subscribe to that existing
       event and re-read /cart.js (single source of truth). The observer
       above then mirrors the value into the drawer heading as before.

   D1/D2  Focus management for the Prestige cart drawer (#p-cd) and
       quick-view (#p-mo). ai1-prestige.js (loaded first) owns the global
       open/close functions that every caller uses (inline onclick,
       ai1-cart-unify.js, ai1-wishlist-cart.js), so we wrap those four
       functions once instead of editing each caller. On open: remember the
       opener and move focus to the Close button. On close (button, overlay,
       Escape): return focus to the opener (fallback: header cart button).
       Tab/Shift+Tab wrap inside the open surface. Closed state is handled in
       CSS (ai1-a11y-fixes.css). No aria-modal is declared: not tested with
       a screen reader.
   ============================================================ */
(function () {
  if (window.__ai1P845Focus) return;
  window.__ai1P845Focus = true;

  /* ---------- D4: keep the header count in sync ---------- */
  var inFlight = false;
  var again = false;

  function refreshCount() {
    if (inFlight) {
      again = true;
      return;
    }
    inFlight = true;
    fetch(window.Shopify.routes.root + 'cart.js', {
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var nav = document.getElementById('cart-badge-count');
        if (nav && (nav.textContent || '').trim() !== String(cart.item_count)) {
          nav.textContent = cart.item_count;
        }
      })
      .catch(function () {})
      .then(function () {
        inFlight = false;
        if (again) {
          again = false;
          refreshCount();
        }
      });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refreshCount);
  }
  // Removing the LAST line on /cart does not reach Dawn's publish() call (its
  // render path throws/returns first), but <cart-items> still toggles its own
  // "is-empty" class from the cart/change response. Re-read cart.js on any
  // class change of <cart-items>; refreshCount is idempotent (no DOM write
  // unless the number differs) so there are no repeated visible updates.
  function watchCartItems() {
    var ci = document.querySelector('cart-items');
    if (ci && 'MutationObserver' in window) {
      new MutationObserver(refreshCount).observe(ci, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchCartItems);
  } else {
    watchCartItems();
  }
  // Back/forward cache restores a stale page without re-running scripts.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) refreshCount();
  });

  /* ---------- D1/D2: focus management ---------- */
  var origOpenCart = window.ai1OpenCart;
  var origCloseCart = window.ai1CloseCart;
  var origOpenModal = window.ai1OpenModal;
  var origCloseModal = window.ai1CloseModal;
  if (
    typeof origOpenCart !== 'function' || typeof origCloseCart !== 'function' ||
    typeof origOpenModal !== 'function' || typeof origCloseModal !== 'function'
  ) {
    return;
  }

  var FOCUSABLE =
    'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),' +
    'textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  var cartOpener = null;
  var modalOpener = null;

  function usable(el) {
    return !!(
      el && el.isConnected && !el.disabled &&
      el.getClientRects().length > 0 &&
      getComputedStyle(el).visibility !== 'hidden'
    );
  }

  function currentFocus() {
    var a = document.activeElement;
    return a && a !== document.body && a !== document.documentElement ? a : null;
  }

  // Right after the "open" class is added the surface can still compute as
  // visibility:hidden for a frame (see ai1-a11y-fixes.css, D1), so retry
  // briefly until the target is focusable, and only while still open.
  function focusFirst(root, selector) {
    var tries = 0;
    (function attempt() {
      var target = root && root.querySelector(selector);
      if (usable(target)) {
        target.focus({ preventScroll: true });
        return;
      }
      if (root && root.classList.contains('open') && ++tries < 12) {
        setTimeout(attempt, 40);
      }
    })();
  }

  function restoreFocus(root, opener, fallbackSelector) {
    var a = currentFocus();
    // Never steal focus the user already moved outside the closing surface.
    if (a && root && !root.contains(a)) return;
    var target = usable(opener)
      ? opener
      : (fallbackSelector ? document.querySelector(fallbackSelector) : null);
    if (usable(target)) target.focus({ preventScroll: true });
  }

  function addDialogSemantics() {
    var cd = document.getElementById('p-cd');
    if (cd && !cd.hasAttribute('role')) {
      cd.setAttribute('role', 'dialog');
      cd.setAttribute('aria-label', 'Your cart');
    }
    var mb = document.querySelector('#p-mo .p-mb');
    if (mb && !mb.hasAttribute('role')) {
      mb.setAttribute('role', 'dialog');
      mb.setAttribute('aria-labelledby', 'p-mt-h');
    }
  }
  addDialogSemantics();

  window.ai1OpenCart = function () {
    var cd = document.getElementById('p-cd');
    var wasOpen = !!(cd && cd.classList.contains('open'));
    if (!wasOpen) {
      var a = currentFocus();
      cartOpener = a && !(cd && cd.contains(a)) ? a : null;
    }
    var res = origOpenCart.apply(this, arguments);
    if (!wasOpen) focusFirst(cd, '.p-cx');
    return res;
  };

  window.ai1CloseCart = function () {
    var cd = document.getElementById('p-cd');
    var wasOpen = !!(cd && cd.classList.contains('open'));
    var res = origCloseCart.apply(this, arguments);
    if (wasOpen) restoreFocus(cd, cartOpener, '.p-cbtn');
    return res;
  };

  window.ai1OpenModal = function (btn) {
    var mo = document.getElementById('p-mo');
    var wasOpen = !!(mo && mo.classList.contains('open'));
    if (!wasOpen) {
      modalOpener = btn && btn.nodeType === 1 ? btn : currentFocus();
    }
    var res = origOpenModal.apply(this, arguments);
    if (!wasOpen) focusFirst(mo, '.p-mt button');
    return res;
  };

  window.ai1CloseModal = function () {
    var mo = document.getElementById('p-mo');
    var wasOpen = !!(mo && mo.classList.contains('open'));
    var res = origCloseModal.apply(this, arguments);
    if (wasOpen) restoreFocus(mo, modalOpener, null);
    return res;
  };

  // One keydown listener: Escape for the quick-view (the cart already has its
  // own Escape listener in ai1-prestige.js, Phase 98g) and Tab wrapping.
  document.addEventListener('keydown', function (e) {
    var mo = document.getElementById('p-mo');
    var cd = document.getElementById('p-cd');
    var moOpen = !!(mo && mo.classList.contains('open'));
    var cdOpen = !!(cd && cd.classList.contains('open'));
    if (!moOpen && !cdOpen) return;

    if (e.key === 'Escape') {
      if (moOpen) window.ai1CloseModal();
      return;
    }
    if (e.key !== 'Tab') return;

    var box = moOpen ? mo.querySelector('.p-mb') : cd;
    if (!box) return;
    var items = Array.prototype.filter.call(box.querySelectorAll(FOCUSABLE), usable);
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    var a = document.activeElement;
    if (!box.contains(a)) {
      e.preventDefault();
      first.focus();
    } else if (e.shiftKey && a === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && a === last) {
      e.preventDefault();
      first.focus();
    }
  });
})();
/* END AI1 PHASE 84.5 */
